import { DictionariesEditPage } from 'features/dictionaries/components/DictionariesEditPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesInventoryEditPage = () => {
  return <DictionariesEditPage type={DictionaryType.Inventory} />
}
